// @flow

import decodeFriend from './decodeFriend';
import decodeEmailUser from './decodeEmailUser';

function decodeGroup(g = {}): FriendGroup {
  const members = g.members
    ? [
        ...g.members.users.map(decodeFriend).map(f => f.id),
        ...g.members.invitations.users.map(decodeFriend).map(f => f.id),
        ...g.members.invitations.emails.map(decodeEmailUser).map(f => f.id)
      ]
    : [];
  return {
    id: g.id || g.name,
    name: g.name,
    count: g.members_count,
    members
  };
}

export default decodeGroup;
